import React, { useEffect, useRef, useState } from 'react';
import useStateRef from 'react-usestateref';
import { useHistory } from 'react-router-dom';
import { APPLICATION_JSON, ZIP_CODE_API_KEY } from '../../middleware/types';
import Helper from '../Helper';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import { checkOutHeaderOptionsAction } from '../../middleware/CheckOutHeaderOptionsAction';

export const RedeemShipping = ({ containerObject, templateName, contentId, dataZone }) => {
    const [hasError, setHasError, setHasErrorRef] = useStateRef(false);
    const history = useHistory();
    const [redeemShippingDetails, setRedeemShippingDetails, redeemShippingDetailsRef] = useStateRef('');
    const [city, setCity, cityRef] = useStateRef('');
    const [state, setState, stateRef] = useStateRef('');
    const [zipCode, setZipCode, zipCodeRef] = useStateRef('');
    const cache = useRef({});
    const [responseCode, setResponseCode] = useState(0);
    const location = useLocation();
    const showDelivery = useSelector(state => state.checkOutHeaderOptions.showDelivery);
    const [search, setSearch, searchRef] = useStateRef('');
    const [errorMessages, setErrorMessages, errorMessagesRef] = useStateRef('')
    const [disabled, setDisabled, disabledRef] = useStateRef(false);
    const errorDivRef = useRef(null);
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)

    useEffect(() => {
        if (loaderStatus == true) {
			console.log("log in redeemShipping page loader true");
		} else {
			console.log("log in redeemShipping page loader false");
        setSearch(window.location.pathname)
        if (searchRef.current && searchRef.current.includes('/voucher/shipping'))
            redeemShipGroupDetails();
        }
    }, [])
    const redeemShipGroupDetails = async () => {
        var actionUrl = 'api/rest/cb/redeem/redeem-shipping-details'
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "GET", false, APPLICATION_JSON, '');
        if (res.result == "success") {
            setRedeemShippingDetails(JSON.parse(res.response).response)
            setZipCode(redeemShippingDetailsRef?.current?.postalCode);
            setCity(redeemShippingDetailsRef?.current?.city);
            setState(redeemShippingDetailsRef?.current?.state)
        } else {
            console.log('res.response...', res.response);
        }
    }


    const clearErrorMsg = () => {
        document.getElementById("errMsgAlert").classList.remove("d-block");
        document.getElementById("errMsgAlert").classList.add("d-none");
    }

    async function handleSubmit(event) {
        event.preventDefault();
        setHasError(false);
        clearErrorMsg();
        setErrorMessages({});
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        var firstName = formData.get("firstName");
        var lastName = formData.get("lastName");
        var email = formData.get("email");
        var phoneNumber = formData.get("phoneNumber");
        var address1 = formData.get("address1");
        var address2 = formData.get("address2");
        var postalCode = formData.get("postalCode");
        var city = formData.get("city");
        var state = formData.get("state");
        var zipcodeApiResponseCode = formData.get("zipcodeApiResponseCode");

        const inputMap = {
            firstName: firstName ? firstName : "",
            lastName: lastName ? lastName : "",
            email: email ? email : "",
            phoneNumber: phoneNumber ? phoneNumber : "",
            address1: address1 ? address1 : "",
            address2: address2 ? address2 : "",
            postalCode: postalCode ? postalCode : "",
            city: city ? city : "",
            state: state ? state : "",
            zipcodeApiResponseCode: zipcodeApiResponseCode ? zipcodeApiResponseCode : "",
            useAVSAddress: "false",
            successURL: "/voucher/delivery",
            failureURL: "/voucher/shipping",
            fedExValidated: "false",
            validateShipping: "Continue"
        }

        if (!setHasErrorRef.current) {
            var actionUrl = "api/rest/cb/redeem//shipping";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))
            var response = JSON.parse(res.response)
            if (res.result == "success" && response.status == "success") {
                if (showDelivery) {
                    history.push("/voucher/delivery");
                } else {
                    history.push("/voucher/review");
                }

            }
            else {
                const responseObj = JSON.parse(res.response);
                const errorMessage = responseObj.errorMessage;
                setErrorMessages(errorMessage);
                let message;
                const errorObject = {};
                errorMessage.map((obj) => {
                    errorObject[obj.key] = obj.message;
                })
                if (errorObject) {
                    document.getElementById("errMsgAlert").classList.remove("d-none");
                    document.getElementById("errMsgAlert").classList.add("d-block");
                    setErrorMessages(errorObject);
                    if (errorDivRef.current) {
                        errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      } 
                }
            }
        }
    }

    const handleChange = (event) => {
        const regex = /^[0-9]+$/;
        const input = event.currentTarget.value;

        if (!regex.test(input)) {
            event.target.value = input.replace(/\D/g, '');
        }
        if (event.currentTarget.id === "phoneNumber" || event.currentTarget.id === "shipping_phoneNumber") {
            const formatted = event.target.value.replace(/(\d{3})(\d{3})?(\d{0,4})?/, (match, p1, p2, p3) => {
                let result = p1;
                if (p2) result += `-${p2}`;
                if (p3) result += `-${p3}`;
                return result;
            });
            event.target.value = formatted
        }
    }

    const handleZipCodeApiResponse = (data) => {

        if (data.error_msg) {
            // We are not showing any error to the user, simply letting the user to enter the data
            setResponseCode(data.error_code);
        } else if ("city" in data) {
            if (document.getElementById('zipcodeApiResponseCode')) {
                setResponseCode(0);
            }
            setCity(data.city);
            setState(data.state);

        } else {
            console.log("data in else ", data);
        }
    }

    // get call to find out city and state
    function getCityAndStateByZipCode(event) {
        setZipCode(event.currentTarget.value);
        setDisabled(true);
        setCity('');
        setState('');
    setTimeout(() => {
        if (zipCodeRef.current == '') {
            console.log('zipcode is empty, city and state cleared...');
            setCity('');
            setState('');
        }
        if (Helper.isValidZipcodeUS(zipCodeRef.current.trim())) {
            if (cache.current[zipCodeRef.current]) {
                console.log("zip code found in cache!!!");
                handleZipCodeApiResponse(cache.current[zipCodeRef.current]);
                setDisabled(false);
            } else {
                console.log("zip code not in cache, making API CALL!!!");
                const url = `https://www.zipcodeapi.com/rest/${ZIP_CODE_API_KEY}/info.json/${zipCodeRef.current.trim()}/radians`;
                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Accept': APPLICATION_JSON,
                    }
                })
                    .then(response => {
                        var responseJson = response.json();
                        return responseJson;
                    })
                    .then(data => {
                        handleZipCodeApiResponse(data);
                        // Store in cache
                        cache.current[zipCodeRef.current] = data;
                        setDisabled(false);
                    })
                    .catch(err => {
                        if (document.getElementById('zipcodeApiResponseCode')) {
                            setResponseCode(err.status);
                        }
                        setDisabled(false);
                    })
            }
        }else{
            console.log('invalid zip and cleared city and state');
            setCity('');
            setState('');
            setDisabled(false);
        }

    },500)
    }

    return (<>
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail redeem-shipping`} >
            <div class="col-12 col-md-11 my-5 c-steps-pd">
                <div class="row">
                    <div class="col-md-12 text-lefalertt mb-3 mx-3 mb-md-0" ref={errorDivRef}>
                        <h1 class="c-account-heading mb-2 mb-md-2">
                            Shipping Address
                        </h1>
                    </div>
                </div>

                <div class="alert alert-danger d-none" id="errMsgAlert" role="alert">
                    {errorMessagesRef.current?.firstName ? <div id="firstNameEmpty">{errorMessagesRef.current?.firstName}</div> : <></>}
                    {errorMessagesRef.current?.lastName ? <div id="lastNameEmpty">{errorMessagesRef.current?.lastName}</div> : <></>}
                    {errorMessagesRef.current?.email ? <div id="emailEmpty">{errorMessagesRef.current?.email}</div> : <></>}
                    {errorMessagesRef.current?.phoneNumber ? <div id="phoneNumberEmpty">{errorMessagesRef.current?.phoneNumber}</div> : <></>}
                    {errorMessagesRef.current?.address1 ? <div id="address1Empty">{errorMessagesRef.current?.address1}</div> : <></>}
                    {errorMessagesRef.current?.postalCode ? <div id="postalCodeEmpty">{errorMessagesRef.current?.postalCode}</div> : <></>}
                    {errorMessagesRef.current?.city ? <div id="cityEmpty">{errorMessagesRef.current?.city}</div> : <></>}
                    {errorMessagesRef.current?.state ? <div id="stateEmpty">{errorMessagesRef.current?.state}</div> : <></>}

                </div>

                <div class="row g-md-5 px-md-4 py-md-4 mx-1">
                    <div class="col-12 col-md-12">
                        <form method="post" autocomplete="on" id="redeem-form" class="c-account-page" data-hs-cf-bound="true" onSubmit={handleSubmit}>

                            <div class="row g-3 g-md-5 mb-3">
                                <div class="col-md-6 col-lg-4 mb-md-2">
                                    <label for="firstName" class="form-label">First Name</label>
                                    <input maxlength="19" autocomplete="firstName" name="firstName" id="firstName" type="text" defaultValue={redeemShippingDetailsRef?.current?.firstName} class={errorMessagesRef.current.firstName ? "form-control form-error" : "form-control"} />
                                </div>
                                <div class="col-md-6 col-lg-4 mb-md-2">
                                    <label for="lastName" class="form-label">Last Name</label>
                                    <input maxlength="19" autocomplete="lastName" name="lastName" id="lastName" type="text" defaultValue={redeemShippingDetailsRef?.current?.lastName} class={errorMessagesRef.current.lastName ? "form-control form-error" : "form-control"} />

                                </div>
                            </div>
                            <div class="row g-3 g-md-5 mb-3">
                                <div class="col-md-6 col-lg-4 mb-md-2">
                                    <label for="email" class="form-label">Email</label>
                                    <input maxlength="255" autocomplete="couponEmail" name="email" id="emailAddress" type="email" defaultValue={redeemShippingDetailsRef?.current?.email} class={errorMessagesRef.current.email ? "form-control form-error" : "form-control"} />

                                </div>
                                <div class="col-md-6 col-lg-4 mb-md-2">
                                    <label for="phone" class="form-label">Phone</label>
                                    <input maxlength="12" autocomplete="couponPhoneNumber" name="phoneNumber" id="phoneNumber" type="text" defaultValue={redeemShippingDetailsRef?.current?.phoneNumber} class={errorMessagesRef.current.phoneNumber ? "form-control form-error" : "form-control"} onChange={handleChange} />

                                </div>
                            </div>

                            <div class="row g-3 g-md-5 mb-3">
                                <div class="col-md-6 col-lg-4 mb-md-2">
                                    <label for="address" class="form-label">Street Address</label>
                                    <input maxlength="40" autocomplete="couponAddress1" name="address1" id="address1" type="text" defaultValue={redeemShippingDetailsRef?.current?.address1} class={errorMessagesRef.current.address1 ? "form-control form-error" : "form-control"} />

                                </div>
                                <div class="col-md-6 col-lg-4 mb-md-2">
                                    <label for="address2" class="form-label">Address 2 (optional)</label>
                                    <input maxlength="40" autocomplete="couponAddress2" name="address2" id="address2" type="text" defaultValue={redeemShippingDetailsRef?.current?.address2} class="form-control" />

                                </div>
                            </div>

                            <div class="row g-3 g-md-5 mb-3">
                                <div class="col-md-6 col-lg-4 mb-md-2">
                                    <label for="zip" class="form-label">Zip</label>
                                    <input maxlength="10" autocomplete="couponPostalCode" name="postalCode" id="postalCode" type="text" value={zipCodeRef.current && zipCodeRef.current ? zipCodeRef.current : ""} class={errorMessagesRef.current.postalCode ? "form-control form-error" : "form-control"} onChange={(e) => getCityAndStateByZipCode(e)} />
                                </div>
                            </div>

                            <div class="row g-3 g-md-5 mb-3">
                                <div class="col-md-6 col-lg-4 mb-md-2">
                                    <label for="city" class="form-label">City</label>
                                    <input maxlength="30" autocomplete="couponCity" name="city" id="city" type="text" onChange={(e) => { setCity(e.currentTarget.value);}} value={cityRef.current ? cityRef.current : ''} class={errorMessagesRef.current.city ? "form-control form-error" : "form-control"} />

                                </div>
                                <div class="col-md-6 col-lg-4 mb-md-2">
                                    <label for="state" class="form-label">State</label>

                                    <select name="state" id="state" class={errorMessagesRef.current.state ? "form-select form-error" : "form-select"} >
                                        <option id="default-select" selected={stateRef.current === '' ? true : false}></option>
                                        <option id="AL" selected={stateRef.current === 'AL' ? true : false} value="AL">AL - Alabama</option>
                                        <option id="AK" selected={stateRef.current === 'AK' ? true : false} value="AK">AK - Alaska</option>
                                        <option id="AZ" selected={stateRef.current === 'AZ' ? true : false} value="AZ">AZ - Arizona</option>
                                        <option id="AR" selected={stateRef.current === 'AR' ? true : false} value="AR">AR - Arkansas</option>
                                        <option id="CA" selected={stateRef.current === 'CA' ? true : false} value="CA">CA - California</option>
                                        <option id="CO" selected={stateRef.current === 'CO' ? true : false} value="CO">CO - Colorado</option>
                                        <option id="CT" selected={stateRef.current === 'CT' ? true : false} value="CT">CT - Connecticut</option>
                                        <option id="DE" selected={stateRef.current === 'DE' ? true : false} value="DE">DE - Delaware</option>
                                        <option id="DC" selected={stateRef.current === 'DC' ? true : false} value="DC">DC - District of Columbia</option>
                                        <option id="FL" selected={stateRef.current === 'FL' ? true : false} value="FL">FL - Florida</option>
                                        <option id="GA" selected={stateRef.current === 'GA' ? true : false} value="GA">GA - Georgia</option>
                                        <option id="HI" selected={stateRef.current === 'HI' ? true : false} value="HI">HI - Hawaii</option>
                                        <option id="ID" selected={stateRef.current === 'ID' ? true : false} value="ID">ID - Idaho</option>
                                        <option id="IL" selected={stateRef.current === 'IL' ? true : false} value="IL">IL - Illinois</option>
                                        <option id="IN" selected={stateRef.current === 'IN' ? true : false} value="IN">IN - Indiana</option>
                                        <option id="IA" selected={stateRef.current === 'IA' ? true : false} value="IA">IA - Iowa</option>
                                        <option id="KS" selected={stateRef.current === 'KS' ? true : false} value="KS">KS - Kansas</option>
                                        <option id="KY" selected={stateRef.current === 'KY' ? true : false} value="KY">KY - Kentucky</option>
                                        <option id="LA" selected={stateRef.current === 'LA' ? true : false} value="LA">LA - Louisiana</option>
                                        <option id="ME" selected={stateRef.current === 'ME' ? true : false} value="ME">ME - Maine</option>
                                        <option id="MD" selected={stateRef.current === 'MD' ? true : false} value="MD">MD - Maryland</option>
                                        <option id="MA" selected={stateRef.current === 'MA' ? true : false} value="MA">MA - Massachusetts</option>
                                        <option id="MI" selected={stateRef.current === 'MI' ? true : false} value="MI">MI - Michigan</option>
                                        <option id="MN" selected={stateRef.current === 'MN' ? true : false} value="MN">MN - Minnesota</option>
                                        <option id="MS" selected={stateRef.current === 'MS' ? true : false} value="MS">MS - Mississippi</option>
                                        <option id="MO" selected={stateRef.current === 'MO' ? true : false} value="MO">MO - Missouri</option>
                                        <option id="MT" selected={stateRef.current === 'MT' ? true : false} value="MT">MT - Montana</option>
                                        <option id="NE" selected={stateRef.current === 'NE' ? true : false} value="NE">NE - Nebraska</option>
                                        <option id="NV" selected={stateRef.current === 'NV' ? true : false} value="NV">NV - Nevada </option>
                                        <option id="NH" selected={stateRef.current === 'NH' ? true : false} value="NH">NH - New Hampshire</option>
                                        <option id="NJ" selected={stateRef.current === 'NJ' ? true : false} value="NJ">NJ - New Jersey</option>
                                        <option id="NM" selected={stateRef.current === 'NM' ? true : false} value="NM">NM - New Mexico</option>
                                        <option id="NY" selected={stateRef.current === 'NY' ? true : false} value="NY">NY - New York</option>
                                        <option id="NC" selected={stateRef.current === 'NC' ? true : false} value="NC">NC - North Carolina</option>
                                        <option id="ND" selected={stateRef.current === 'ND' ? true : false} value="ND">ND - North Dakota</option>
                                        <option id="OH" selected={stateRef.current === 'OH' ? true : false} value="OH">OH - Ohio</option>
                                        <option id="OK" selected={stateRef.current === 'OK' ? true : false} value="OK">OK - Oklahoma</option>
                                        <option id="OR" selected={stateRef.current === 'OR' ? true : false} value="OR">OR - Oregon</option>
                                        <option id="PA" selected={stateRef.current === 'PA' ? true : false} value="PA">PA - Pennsylvania</option>
                                        <option id="RI" selected={stateRef.current === 'RI' ? true : false} value="RI">RI - Rhode Island</option>
                                        <option id="SC" selected={stateRef.current === 'SC' ? true : false} value="SC">SC - South Carolina</option>
                                        <option id="SD" selected={stateRef.current === 'SD' ? true : false} value="SD">SD - South Dakota</option>
                                        <option id="TN" selected={stateRef.current === 'TN' ? true : false} value="TN">TN - Tennessee</option>
                                        <option id="TX" selected={stateRef.current === 'TX' ? true : false} value="TX">TX - Texas</option>
                                        <option id="UT" selected={stateRef.current === 'UT' ? true : false} value="UT">UT - Utah</option>
                                        <option id="VT" selected={stateRef.current === 'VT' ? true : false} value="VT">VT - Vermont</option>
                                        <option id="VA" selected={stateRef.current === 'VA' ? true : false} value="VA">VA - Virginia</option>
                                        <option id="WA" selected={stateRef.current === 'WA' ? true : false} value="WA">WA - Washington</option>
                                        <option id="WV" selected={stateRef.current === 'WV' ? true : false} value="WV">WV - West Virginia</option>
                                        <option id="WI" selected={stateRef.current === 'WI' ? true : false} value="WI">WI - Wisconsin</option>
                                        <option id="WY" selected={stateRef.current === 'WY' ? true : false} value="WY">WY - Wyoming</option>
                                    </select>
                                </div>
                            </div>
                            <input id="zipcodeApiResponseCode" name="zipcodeApiResponseCode" type="hidden" value={responseCode} />
                            <div class="row g-0 g-md-5 mb-3 my-md-4">
                                <div class="col-md-4 d-grid cb-form-section">
                                    <input name="validateShipping" id="reviewRequest" disabled={disabledRef.current == true ? true:""} type="submit" value="Continue" class="btn btn-primary block" />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}
